// useGamification.js
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initNotificationIntegration } from '../store/gamification-action';

const useGamification = () => {
    const dispatch = useDispatch();
    const initialized = useRef(false);
    const user = useSelector((state) => state.auth.user);

    useEffect(() => {
        if (!initialized.current && user) {
            dispatch(initNotificationIntegration(user));
            initialized.current = true; // Ensure it only initializes once
        }
    }, [dispatch, user]);
};

export default useGamification;
